<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12 ">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex">
          <div class="col-sm-12 col-xs-12">
            <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
              <h3 class="title">전자계약</h3>
              <h5 class="desc">물품 공급 계약, 장비 계약 등 각종 계약을 관리할 수 있습니다.</h5>
            </div>
          </div>
        </div>
        <div class="small-header">
          신규 계약 추가하기
        </div>
        <a-row type="flex" align="middle" :gutter=30 justify="center">
          <a-col class="col-sm-12 col-xs-12 contract-container">
            <div class="contract-title">
              물품 매매 계약서
            </div>
            <div class="contract-section-wrap">
              <div class="contract-section-title">매수인 (고객)</div>
              <div class="contract-items-container">
                <contract-item-wrap
                    label="고객 상호"
                    :is-required="true"
                    :class="'fixed-btn-110 mobile-wrap'"
                    :errorIds="['company-name-error']"
                >
                  <div class="disabled-event-wrap">
                    <input
                        ref="companyName"
                        type="text"
                        class="ant-like-input"
                        :disabled="!directInputClientName && !clientNameLengthExceeded"
                        v-model="clientData.companyName"
                        @input="uiHandler.handleClientNameInput"
                        :placeholder="directInputClientName ? '거래처 이름을 입력해주세요' : '거래처 검색을 통해 입력해주세요'"
                    />
                    <!-- 상호 칸을 클릭하면 거래처 검색 모달을 띄우는 투명 오버레이.
                         길이 초과로 상호를 직접 줄여야 할 때는 오버레이를 걷어야 타이핑이 된다. -->
                    <div
                        v-if="!directInputClientName && !clientNameLengthExceeded"
                        class="fire-event-container"
                        @click="uiHandler.handleModal.client.show"
                    />
                  </div>
                  <div class="checkbox-container">
                    <a-checkbox v-model:checked="directInputClientName" @change="uiHandler.checkDirectInputClientName">직접입력</a-checkbox>
                  </div>
                  <!-- 길이 초과 시에만 노출. 괄호 안이 영문·숫자·공백뿐일 때(영문 별칭으로 판단될 때)만
                       제거를 제안하고, 최종 확정은 사용자가 누른다. 괄호 안에 한글 병원명이 들어있는
                       거래처(예: 의료법인OO재단OO지점(OO치과의원))는 후보에서 자동 제외된다. -->
                  <button
                      v-if="clientNameLengthExceeded && clientNameAliasStripCandidate"
                      class="btn-darkgray btn-hover"
                      type="button"
                      @click="uiHandler.stripClientNameAlias">
                    영문 별칭 제거
                  </button>
                  <button class="btn-darkgray btn-hover"
                          :disabled="directInputClientName"
                          @click="uiHandler.handleModal.client.show">
                    거래처 검색
                  </button>
                </contract-item-wrap>

                <contract-item-wrap
                    label="주소"
                    :is-required="true"
                    :class="'fixed-btn-110 mobile-wrap'"
                    :errorIds="['address-error']"
                >
                  <div class="disabled-event-wrap">
                    <textarea
                        maxlength="67"
                        type="text"
                        v-model="clientData.address"
                        ref="address"
                        placeholder="주소 검색을 통해 입력해주세요"
                        class="address ant-like-input"
                        style="width: 100%;"
                    />
                  </div>
                  <div class="button-wrapper">
                    <button class="btn-darkgray btn-hover" @click="uiHandler.searchAddress">
                      주소 검색
                    </button>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    label="대표자 정보"
                    :is-required="true"
                    :class="'divide-two'"
                    :errorIds="['ceo-name-error', 'ceo-birthday-error']"
                >
                  <div class="input-area">
                    <input
                        class="full-width ant-like-input"
                        type="text"
                        placeholder="이름 입력"
                        ref="ceoName"
                        v-model="clientData.ceo.name"
                        @input="uiHandler.handleRemoveError('ceoName', 'ceo-name-error')"
                    />
                  </div>
                  <div class="input-area calendar" ref="ceoBirthday">
                    <a-date-picker
                        type="date"
                        class="contract-item width-100"
                        placeholder="생년월일"
                        v-model:value="clientData.ceo.birthday"
                        :locale="locale"
                        :bordered="false"
                        @change="uiHandler.handleCeoBirthday"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    label="연락처"
                    :is-required="true"
                    :errorIds="['mobile-error']"
                >
                  <div class="input-area icon" ref="companyMobileNumber">
                    <i class="fa-solid fa-mobile-screen"/>
                    <input
                        class="full-width"
                        type="text"
                        maxlength="13"
                        placeholder="010-0000-0000"
                        v-model="clientData.contact.mobile"
                        @input="uiHandler.changeMobileNumber(true)"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    label="면허번호"
                    :is-required="true"
                    :errorIds="['license-no-error']"
                >
                  <input
                      type="text"
                      class="fixed-width-200 ant-like-input"
                      ref="licenseNo"
                      placeholder="면허번호 입력"
                      v-model="clientData.licenseNo"
                      @input="uiHandler.handleRemoveError('licenseNo', 'license-no-error')"
                  />
                </contract-item-wrap>
              </div>
            </div>
            <div class="contract-section-wrap">
              <div class="contract-section-title">계약 내용</div>
              <div class="contract-items-container">
                <contract-item-wrap
                    label="계약일"
                    :is-required="true"
                    :errorIds="['contract-date-error']"
                >
                  <div class="custom-calendar-wrap single" ref="contractDate">
                    <a-date-picker
                        type="date"
                        class="contract-item"
                        placeholder="계약 일자"
                        v-model:value="contractDate"
                        :locale="locale"
                        :bordered="false"
                        @change="uiHandler.handleContractDate"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    label="총 계약 금액"
                    :is-required="true"
                    :errorIds="['total-price-error']"
                >
                  <div class="custom-unit-wrap" ref="totalPrice">
                    <input
                        type="text"
                        :value="formattedTotalPrice"
                        @click="uiHandler.removeTotalPrice"
                        @focusout="uiHandler.addZeroToTotalPrice"
                        @input="uiHandler.handleTotalPrice"
                    />
                    <div class="unit">원</div>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap label="임플란트">
                  <div class="custom-unit-wrap">
                    <input
                        type="text"
                        :value="formatCommaNumber(itemAmounts.implant)"
                        @input="uiHandler.handleItemAmount('implant', $event)"
                    />
                    <div class="unit">원</div>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap label="재료">
                  <div class="custom-unit-wrap">
                    <input
                        type="text"
                        :value="formatCommaNumber(itemAmounts.material)"
                        @input="uiHandler.handleItemAmount('material', $event)"
                    />
                    <div class="unit">원</div>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap label="장비">
                  <div class="custom-unit-wrap">
                    <input
                        type="text"
                        :value="formatCommaNumber(itemAmounts.equipment)"
                        @input="uiHandler.handleItemAmount('equipment', $event)"
                    />
                    <div class="unit">원</div>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap label="기타">
                  <div class="custom-unit-wrap">
                    <input
                        type="text"
                        :value="formatCommaNumber(itemAmounts.etc)"
                        @input="uiHandler.handleItemAmount('etc', $event)"
                    />
                    <div class="unit">원</div>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap label="프로모션코드">
                  <input
                      type="text"
                      class="fixed-width-200 ant-like-input"
                      placeholder="프로모션코드 입력"
                      v-model="contractInfo.promotionCode"
                  />
                </contract-item-wrap>
                <contract-item-wrap
                    label="단가 할인율"
                    :is-required="true"
                    :errorIds="['discount-rate-error']"
                >
                  <div class="custom-unit-wrap " ref="discountRate">
                    <input
                        type="text"
                        maxlength="5"
                        placeholder="0.00"
                        v-model="contractInfo.discountRate"
                        @input="uiHandler.handlePercentage"
                    />
                    <div class="unit">%</div>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap label="결제 방법" :is-required="true" :errorIds="['payment-method-error', 'card-company-error']">
                  <div class="radio-btn-container">
                    <div
                        v-for="(item, index) in paymentMethods"
                        class="radio-item"
                        :key="index"
                    >
                      <input
                          class="radio-input"
                          type="radio"
                          :value="item"
                          :id="`payment-${index}`"
                          v-model="selectedPaymentMethod"
                          @change="uiHandler.handlePaymentMethod(item)"
                      />
                      <label class="radio-label" :for="`payment-${index}`">{{ item.displayName }}</label>
                      <!-- 카드사명은 신용카드 라디오 바로 옆에 붙인다 (결제 조건의 '개월' 입력칸과 동일 패턴) -->
                      <!-- 계약서 PDF의 "(  )신용카드" 괄호 실폭이 22pt라 한글 2자까지만 인쇄됨 → 약칭 입력 유도 -->
                      <div
                          class="input-wrap-small"
                          v-if="item.name === '신용카드' && selectedPaymentMethod && selectedPaymentMethod.name === '신용카드'"
                          ref="cardCompany"
                      >
                        <input
                            type="text"
                            placeholder="예: 삼성, 국민"
                            maxlength="2"
                            v-model="cardCompany"
                            @input="uiHandler.handleRemoveError('cardCompany', 'card-company-error')"
                        />
                      </div>
                    </div>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap label="결제 조건" :is-required="true" :errorIds="['payment-condition-error', 'payment-months-error']">
                  <div class="radio-btn-container no-flex">
                    <div
                        v-for="(item, index) in paymentConditions"
                        class="radio-item"
                        :key="index"
                    >
                      <input
                          class="radio-input"
                          type="radio"
                          :value="item"
                          :id="`condition-${index}`"
                          v-model="selectedPaymentCondition"
                          @change="uiHandler.handlePaymentCondition(item)"
                      />
                      <label class="radio-label" :for="`condition-${index}`">{{ item.displayName }}</label>
                      <div
                          class="input-wrap-small"
                          :class="selectedPaymentCondition === item ? '' : 'inactive'"
                          v-if="item.hasMonths"
                      >
                        <input
                            type="text"
                            max-length="2"
                            :disabled="selectedPaymentCondition !== item"
                            v-model="paymentMonths"
                            @input="uiHandler.handlePaymentMonths"
                        />
                        개월
                      </div>
                    </div>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap label="첫 결제 예정일" :is-required="true" :errorIds="['first-payment-date-error']">
                  <div class="custom-calendar-wrap single" ref="firstPaymentDate">
                    <a-date-picker
                        type="date"
                        class="contract-item"
                        placeholder="첫 결제 예정일"
                        :locale="locale"
                        :bordered="false"
                        v-model:value="firstPaymentDate"
                        @change="uiHandler.handleFirstPaymentDate"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap label="비고" :is-required="false" :errorIds="['description-error']">
                  <div class="contract-item-input-wrap" ref="description">
                    <a-textarea
                        class="full-width"
                        placeholder="최대 4줄까지 입력 가능합니다."
                        v-model:value="contractInfo.description"
                        :auto-size="{ minRows: 2, maxRows: 4 }"
                        :maxlength="190"
                        @input="uiHandler.limitTextToFourLines"
                    />
                  </div>
                </contract-item-wrap>
              </div>
            </div>
            <div class="contract-section-wrap">
              <div class="contract-section-title">영업담당자 확인</div>
              <div class="contract-items-container">
                <contract-item-wrap
                    label="지점명"
                    :is-required="true"
                    :errorIds="['branch-error']"
                >
                  <div class="input-area name" ref="branch">
                    <input
                        class="full-width"
                        type="text"
                        placeholder="지점명 입력"
                        v-model="confirmInfo.branch"
                        @input="uiHandler.handleRemoveError('branch', 'branch-error')"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    v-for="(row, index) in staffRows"
                    :key="index"
                    :label="row.displayLabel"
                    :is-required="row.role === '담당자'"
                    :class="'divide-two'"
                    :errorIds="[`staff-${index}-name-error`, `staff-${index}-mobile-error`]"
                >
                  <div class="input-area name" :ref="`staffSelect${index}`" style="flex-direction: column; align-items: stretch;">
                    <a-select
                        show-search
                        style="width: 100%;"
                        :value="row.accountId"
                        :options="uiHandler.accountOptionsFor(row)"
                        :filter-option="uiHandler.filterAccountOption"
                        :disabled="excludableStaffRoles.includes(row.role) && row.excluded"
                        placeholder="담당자 검색/선택"
                        @change="val => uiHandler.onSelectStaff(index, val)"
                    />
                    <div v-if="excludableStaffRoles.includes(row.role)" class="checkbox-container" style="margin-top: 6px;">
                      <a-checkbox v-model:checked="row.excluded" @change="() => uiHandler.handleStaffExcluded(row)">{{ row.role }} 없음</a-checkbox>
                    </div>
                  </div>
                  <div class="input-area icon" :ref="`staffMobile${index}`">
                    <i class="fa-solid fa-mobile-screen"/>
                    <input
                        type="text"
                        maxlength="13"
                        placeholder="010-0000-0000"
                        :disabled="excludableStaffRoles.includes(row.role) && row.excluded"
                        v-model="row.mobile"
                        @input="uiHandler.changeStaffMobile(index)"
                    />
                  </div>
                </contract-item-wrap>
              </div>
            </div>
            <div class="contract-section-wrap">
              <div class="contract-section-title">별첨</div>
              <div class="contract-items-container">
                <contract-item-wrap
                    v-for="(item, index) in attach2Items"
                    :key="index"
                    :label="item.groupLabel"
                    :errorIds="[`attach2-${index}-error`]"
                >
                  <div class="checkbox-container">
                    <a-checkbox v-model:checked="item.checked">해당</a-checkbox>
                  </div>
                  <input
                      type="text"
                      class="fixed-width-200 ant-like-input"
                      placeholder="코드 입력"
                      v-model="item.code"
                  />
                </contract-item-wrap>
                <!-- 덴티움 요청(2026-07-28): 설치(배송) 희망일은 선택 입력 -->
                <contract-item-wrap
                    label="설치(배송) 희망일"
                    :is-required="false"
                    :errorIds="['install-date-error']"
                >
                  <div class="custom-calendar-wrap single" ref="installDate">
                    <a-date-picker
                        type="date"
                        class="contract-item"
                        placeholder="설치(배송) 희망일"
                        :locale="locale"
                        :bordered="false"
                        v-model:value="confirmInfo.installDate"
                        @change="uiHandler.handleInstallDate"
                    />
                  </div>
                </contract-item-wrap>
              </div>
            </div>
            <div class="contract-footer">
              <button
                  class="contract-cancel-btn btn-hover"
                  @click="$router.push(contractTypesPath)"
              >
                취소
              </button>
              <button
                  class="contract-submit-btn btn-hover preview-button"
                  @click="uiHandler.handleModal.contractDraftModal.show"
              >
                미리보기
              </button>
              <button
                  class="contract-submit-btn btn-hover"
                  @click="(uiHandler.createTempContract)"
                  style="font-weight: 700;"
              >
                계약서 임시저장
              </button>
              <button
                  class="contract-submit-btn btn-hover"
                  @click="uiHandler.handleModal.summary.show"
                  style="font-weight: 700;"
              >
                계약서 작성 완료
              </button>
            </div>
          </a-col>
          <a-col></a-col>
          <a-col class="col-sm-12 col-xs-12 contract-container is-desktop-only">
            <div class="contract-title">
              미리보기
              <LottieAnimation
                  v-if="previewLoading"
                  :animation-data="loadingAnimation"
                  :auto-play="true"
                  :loop="true"
                  :speed="1"
                  class="lottie-player-component loading-img"
                  ref="anim"
              />
              <a-button v-else type="primary" @click="uiHandler.makeContractDraft">
                <i class="fa-solid fa-rotate-right"></i><span style="margin-left: 5px">새로고침</span>
              </a-button>
            </div>
            <div class="iframe-wrap">
              <iframe :src=modal.contractDraft.embeddedUrl class="preview-iframe" style="height: 975px"></iframe>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
  <search-client-modal
      :show-modal="modal.client.show"
      @close-modal="uiHandler.handleModal.client.close"
      @complete-search="uiHandler.handleModal.client.handleEvent.selectClient"
  />
  <summary-contract-modal
      :show-modal="modal.summary.show"
      :summary-contents="summary"
      @summary-confirm="uiHandler.handleModal.summary.handleEvent.summaryConfirm"
      @close-modal="uiHandler.handleModal.summary.close"
  />
  <create-contract-success-modal-v2
      :show-modal="modal.createSuccess.show"
      :secure-link-param="secureLinkParam"
      :contract-type="contractType"
      @close-modal="uiHandler.handleModal.createSuccess.close"
  />
  <contract-draft-modal
      :show-modal="modal.contractDraft.show"
      :embedded-url="modal.contractDraft.embeddedUrl"
      @close-modal="uiHandler.handleModal.contractDraftModal.close"
  />
</template>
<script>
import { getProfile } from '@/utils/tokenStore';
import {
  oneBtnDialog,
  phoneNumberFormatter,
  formatCommaNumber,
  logging,
  businessNumberFormatter, twoBtnDialog,
} from '@/utils/utils';
import {
  RouterEnum,
} from '@/enums/router.enums';
import ContractItemWrap from '@/views/ContractManagement/components/ContractItemWrap';
import SignModal from '@/views/ContractManagement/components/SignModal';
import SearchClientModal from '@/views/ContractManagement/components/SearchClientModal';
import {localStorageEnums} from "@/enums/localStorage.enums";
import SummaryContractModal from "@/views/ContractManagement/components/SummaryContractModal.vue";
import CreateContractSuccessModalV2 from "@/views/ContractManagementV2/components/CreateContractSuccessModalV2.vue";
// ModuSignMethod는 payload/mulpumV6Payload.js로 옮겨간 makeContractParam 안에서만 쓰였다
// (여기선 더 이상 필요 없음). ContractTypeEnum은 data()의 contractType 기본값에 계속 쓴다.
import {ContractTypeEnum} from "@/views/ContractManagement/enums";
import {
  validateContractClientNameLength,
  stripAsciiParenthetical
} from "@/views/ContractManagement/contracts/contractValidationUtils";
import ContractDraftModal from "@/views/ContractManagement/components/ContractDraftModal.vue";
import {LottieAnimation} from "lottie-web-vue";
import loadingAnimation from "@/assets/img/loading.json";
// v2: contracts-api 전용 api 모듈 + axios 인스턴스 (v1의 @/views/ContractManagement/api,
// this.$apiInstance 대신). SearchClientModal 등 재사용 중인 v1 공용 모달 컴포넌트는 자체 api()에서
// 여전히 this.$apiInstance(v1/inapi)를 쓴다 — 이번 라운드는 그 모달들을 손대지 않고 그대로 재사용한다
// (거래처 검색 등 부속 기능까지 contracts-api로 옮기는 것은 이 화면의 범위 밖).
import contractApi from "@/views/ContractManagementV2/api";
import contractsApiInstance from "@/contractsApi";
import {buildMulpumV6Payload} from "@/views/ContractManagementV2/payload/mulpumV6Payload";
import {resolveContractCreateRouteName} from "@/views/ContractManagementV2/routeMap";
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import dayjs from 'dayjs';

import {CONTRACT_TYPES_PATH} from '@/utils/contractConsole';
/**
 * 모두싸인 SECURE_LINK 수신번호로 쓸 수 있는 형식인지 검사한다.
 *
 * 미리보기(초안 생성)는 서명자 연락처를 그대로 모두싸인에 넘기는데,
 * 모두싸인은 형식이 어긋나면 400(Signing method value must be email or phone number string)을 낸다.
 * 입력 핸들러는 하이픈 포맷팅만 하므로 "010-1234"(입력 중)·"010 1234 5678"(붙여넣기) 같은
 * 미완성 값이 그대로 남을 수 있어, 미리보기 호출 전에 형식까지 검사한다.
 * (발송 경로는 기존 validateMobileNumber가 더 엄격하게 검증한다)
 */
// 010-XXXX-XXXX = 11자리, 011/016/017/018/019-XXX-XXXX = 10자리. 즉 "01" 뒤에 8~9자리다.
// {7,8}(총 9~10자리)로 잡으면 현행 010 번호가 전부 탈락해 정상 연락처를 폼에서 반려한다(2026-08-04 운영 회귀).
const isModuSignMobile = (mobile) => /^01[0-9]{8,9}$/.test(String(mobile || '').replace(/\D/g, ''));

export default {
  // v1 라우트 name("덴티움 물품 매매 계약서")에 routeMap.js의 단일 매핑을 적용해 v2 name을 얻는다
  // (라우트 등록(router/index.js)과 반드시 같은 값이어야 하므로 하드코딩하지 않는다).
  name: resolveContractCreateRouteName(RouterEnum.ContractManagement.Contracts.Dentium.MulpumV6.name),
  components: {
    LottieAnimation,
    ContractDraftModal,
    CreateContractSuccessModalV2,
    SummaryContractModal,
    ContractItemWrap,
    SignModal,
    SearchClientModal,
  },
  props: {
    templateId: {
      type: String,
      required: true,
    }
  },
  computed: {
    formattedTotalPrice() {
      return formatCommaNumber(this.contractInfo.totalPrice);
    },
    /**
     * 영문 별칭을 제거한 상호 후보. 제거해도 길이가 줄지 않거나
     * 결과가 비면 null 을 돌려 제안 버튼을 감춘다.
     */
    clientNameAliasStripCandidate() {
      const stripped = stripAsciiParenthetical(this.clientData.companyName);
      if (!stripped || stripped === this.clientData.companyName) return null;
      return stripped;
    },
  },
  data() {
    return {
      makeContractDraftDebouncing: null,
      loadingAnimation,
      logging,
      locale,
      formatCommaNumber,
      uiHandler: this.ui(),
      apiHandler: this.api(),
      contractTypesPath: CONTRACT_TYPES_PATH,
      pageTitle: this.$route.query.name ?? '',
      contractTitle: '물품매매계약서',
      contractType: ContractTypeEnum.물품매매V4,
      contractCreator: '',
      previewLoading: false,
      modal: {
        client: {
          show: false
        },
        sign: {
          show: false,
        },
        summary: {
          show: false,
        },
        createSuccess: {
          show: false,
        },
        contractDraft: {
          embeddedUrl: '',
          show: false
        }
      },
      summary: {
        "계약명": "",
        "병원명": "",
        "병원장명": "",
        "병원 주소": "",
        "병원 연락처": "",
        "총 계약 금액": "",
      },
      secureLinkParam: {
        contractId: '',
        participantId: '',
      },
      directInputClientName: false,
      // 거래처 상호가 모두싸인 metadata 80자 제한을 넘겼을 때 true.
      // 상호 입력칸의 잠금을 풀어 사용자가 직접 줄일 수 있게 한다.
      // 한 번 열리면 거래처를 다시 선택하거나 직접입력을 토글할 때까지 열린 상태를 유지한다.
      // (타이핑 도중 한도 아래로 내려가는 순간 칸이 다시 잠기면 입력이 끊긴다)
      clientNameLengthExceeded: false,
      clientData: {
        companyName: '',
        address: '',
        cNo: '',
        licenseNo: '',
        ceo: {
          name: '',
          birthday: null,
        },
        contact: {
          phone: '',
          mobile: '',
          email: '',
        },
        rawHospitalData: {},
      },
      // v4(2026-07-24 penny 개정): 5항목(임플란트/리제너레이션/장비/인테리어/기타) → 4항목(임플란트/재료/장비/기타)
      itemAmounts: {
        implant: 0,
        material: 0,
        equipment: 0,
        etc: 0,
      },
      contractInfo: {
        totalPrice: 0,
        description: '',
        discountRate: '',
        promotionCode: '',
      },
      // 결제 방법 (DTO 값과 동일하게 name 저장 — CMS 는 'cms')
      paymentMethods: [
        {name: '역구매', displayName: '역구매'},
        {name: '신용카드', displayName: '신용카드'},
        {name: 'cms', displayName: 'CMS'},
        {name: '계좌이체', displayName: '계좌이체'},
        {name: '기타', displayName: '기타'},
      ],
      selectedPaymentMethod: null,
      // v4 신규: 신용카드 선택 시 카드사명 입력
      cardCompany: '',
      // v4(2026-07-24 penny 개정): 결제 조건에 "카드일시불" 추가 (개월수 없음)
      paymentConditions: [
        {name: '역구매분납', displayName: '역구매분납', hasMonths: true},
        {name: '카드일시불', displayName: '카드일시불', hasMonths: false},
        {name: '분납', displayName: '분납', hasMonths: true},
        {name: '일시불', displayName: '일시불', hasMonths: false},
      ],
      selectedPaymentCondition: null,
      paymentMonths: '',
      firstPaymentDate: dayjs(),
      contractDate: dayjs(),
      confirmInfo: {
        branch: '',
        // v4 신규(별첨3): 설치(배송) 희망일
        installDate: null,
      },
      // 영업담당자 서명자 (담당자 필수, 지점장/센터장 선택 — "없음" 체크 시 서명 참여 제외)
      // v4(2026-07-24 penny 개정): 라벨 담당자→담당자명 / 지점장→지점명 / 센터장→센터명 (role 값 자체는 백엔드 계약 유지 위해 보존)
      // 지점장 부재 지점(제주 영업소 등)이 실존하여 지점장도 제외 가능 (2026-08-07 영업팀 요청)
      excludableStaffRoles: ['지점장', '센터장'],
      staffRows: [
        {role: '담당자', displayLabel: '담당자명', accountId: null, name: '', deptName: '', mobile: '', excluded: false},
        {role: '지점장', displayLabel: '지점명', accountId: null, name: '', deptName: '', mobile: '', excluded: false},
        {role: '센터장', displayLabel: '센터명', accountId: null, name: '', deptName: '', mobile: '', excluded: false},
      ],
      managerAccounts: [],
      accountOptions: [],
      // v4 신규(별첨2): 프로모션/구성 코드 — 그룹별 체크박스 + 자유입력 코드
      attach2Items: [
        {group: 'implant', groupLabel: '임플란트프로모션', checked: false, code: ''},
        {group: 'material', groupLabel: '재료프로모션', checked: false, code: ''},
        {group: 'equipment', groupLabel: '장비단품', checked: false, code: ''},
        {group: 'impMaterial', groupLabel: '임플란트+재료', checked: false, code: ''},
        {group: 'impEquipment', groupLabel: '임플란트+장비', checked: false, code: ''},
      ],
    }
  },
  async created() {
    // 결제 방법/조건 기본 선택 (V1 패턴) — 미선택 상태로 미리보기 초안 생성 시 BE 화이트리스트 예외 방지
    this.selectedPaymentMethod = this.paymentMethods[0];
    this.selectedPaymentCondition = this.paymentConditions[0];
  },
  async mounted() {
    await this.uiHandler.getUserInfo();
    await this.uiHandler.loadManufacturerAccounts();
    await this.uiHandler.makeContractDraft();
    await this.uiHandler.loadTempContract();
    // 이벤트 리스너 등록
    window.removeEventListener('resize', this.uiHandler.checkScreenSizeAndFetch);
    window.addEventListener('resize', this.uiHandler.checkScreenSizeAndFetch);
  },
  beforeDestroy() {
    // 컴포넌트가 사라질 때 이벤트 리스너 해제
    window.removeEventListener('resize', this.uiHandler.checkScreenSizeAndFetch);
  },
  methods: {
    twoBtnDialog,
    ui() {
      const removeTotalPrice = (e) => {
        if (this.contractInfo.totalPrice === 0) e.target.value = '';
        return;
      }
      const addZeroToTotalPrice = (e) => {
        if (this.contractInfo.totalPrice === 0) e.target.value = '0';
        return;
      }
      const handleTotalPrice = (e) => {
        if (e.target.value === '00') {
          e.target.value = '0';
          this.contractInfo.totalPrice = 0;
        }
        if (isNaN(e.target.value)) e.target.value = e.target.value.replace(/[^0-9]/g, '');
        this.contractInfo.totalPrice = parseInt(e.target.value.replace(/[^0-9]/g, '')) || 0;
        this.$refs.totalPrice.classList.remove('error');
        document.getElementById('total-price-error').innerHTML = '';
      }

      const validateRequiredValues = async () => {
        Object.values(this.$refs).forEach(ref => {
          if (ref && ref.classList && ref.classList.contains('error')) {
            ref.classList.remove('error');
          }
        });
        let result = true;
        if (!this.clientData.companyName) {
          this.$refs.companyName.classList.add('error');
          document.getElementById('company-name-error').innerHTML = '거래처를 선택해 주세요.';
          result = false;
        } else {
          this.$refs.companyName.classList.remove('error');
          document.getElementById('company-name-error').innerHTML = '';
        }
        if (!this.clientData.address) {
          this.$refs.address.classList.add('error');
          document.getElementById('address-error').innerHTML = '주소를 입력해 주세요.';
          result = false;
        } else {
          this.$refs.address.classList.remove('error');
          document.getElementById('address-error').innerHTML = '';
        }
        if (!this.clientData.ceo.name.trim()) {
          this.$refs.ceoName.classList.add('error');
          document.getElementById('ceo-name-error').innerHTML = '대표자 이름을 입력해 주세요.';
          result = false;
        } else if (this.clientData.ceo.name.trim().length < 2) {
          this.$refs.ceoName.classList.add('error');
          document.getElementById('ceo-name-error').innerHTML = '이름은 최소 2글자 이상으로 작성해 주세요.';
          result = false;
        } else {
          this.$refs.ceoName.classList.remove('error');
          document.getElementById('ceo-name-error').innerHTML = '';
        }
        if (!this.clientData.ceo.birthday) {
          this.$refs.ceoBirthday.classList.add('error');
          document.getElementById('ceo-birthday-error').innerHTML = '대표자의 생년월일을 입력해 주세요.';
          result = false;
        } else {
          this.$refs.ceoBirthday.classList.remove('error');
          document.getElementById('ceo-birthday-error').innerHTML = '';
        }
        if (!this.clientData.contact.mobile) {
          this.$refs.companyMobileNumber.classList.add('error');
          document.getElementById('mobile-error').innerHTML = '휴대폰 번호를 입력해 주세요.';
          result = false;
        } else {
          this.$refs.companyMobileNumber.classList.remove('error');
          document.getElementById('mobile-error').innerHTML = '';
        }
        if (!this.clientData.licenseNo || !this.clientData.licenseNo.trim()) {
          this.$refs.licenseNo.classList.add('error');
          document.getElementById('license-no-error').innerHTML = '면허번호를 입력해 주세요.';
          result = false;
        } else {
          this.$refs.licenseNo.classList.remove('error');
          document.getElementById('license-no-error').innerHTML = '';
        }

        if (!this.selectedPaymentMethod) {
          document.getElementById('payment-method-error').innerHTML = '결제 방법을 선택해 주세요.';
          result = false;
        } else {
          document.getElementById('payment-method-error').innerHTML = '';
          if (this.selectedPaymentMethod.name === '신용카드' && !String(this.cardCompany).trim()) {
            document.getElementById('card-company-error').innerHTML = '카드사명을 입력해 주세요.';
            result = false;
          } else {
            document.getElementById('card-company-error').innerHTML = '';
          }
        }

        if (!this.selectedPaymentCondition) {
          document.getElementById('payment-condition-error').innerHTML = '결제 조건을 선택해 주세요.';
          result = false;
        } else {
          document.getElementById('payment-condition-error').innerHTML = '';
          if (this.selectedPaymentCondition.hasMonths && !String(this.paymentMonths).trim()) {
            document.getElementById('payment-months-error').innerHTML = '납부 개월수를 입력해 주세요.';
            result = false;
          } else {
            document.getElementById('payment-months-error').innerHTML = '';
          }
        }

        if (!this.firstPaymentDate) {
          this.$refs.firstPaymentDate.classList.add('error');
          document.getElementById('first-payment-date-error').innerHTML = '첫 결제 예정일을 입력해 주세요.';
          result = false;
        } else {
          this.$refs.firstPaymentDate.classList.remove('error');
          document.getElementById('first-payment-date-error').innerHTML = '';
        }

        if (!this.confirmInfo.branch.trim()) {
          this.$refs.branch.classList.add('error');
          document.getElementById('branch-error').innerHTML = '지점명을 입력해 주세요.';
          result = false;
        } else {
          this.$refs.branch.classList.remove('error');
          document.getElementById('branch-error').innerHTML = '';
        }

        // 설치(배송) 희망일은 선택 입력 (덴티움 요청 2026-07-28) → 미입력이어도 통과
        this.$refs.installDate.classList.remove('error');
        document.getElementById('install-date-error').innerHTML = '';

        if (!this.contractDate) {
          this.$refs.contractDate.classList.add('error');
          document.getElementById('contract-date-error').innerHTML = '계약일을 입력해 주세요.';
          result = false;
        } else {
          this.$refs.contractDate.classList.remove('error');
          document.getElementById('contract-date-error').innerHTML = '';
        }

        // 영업담당자 서명자 검증 (지점장/센터장 "없음" 체크 시 스킵)
        this.staffRows.forEach((row, index) => {
          const nameEl = document.getElementById(`staff-${index}-name-error`);
          const mobileEl = document.getElementById(`staff-${index}-mobile-error`);
          const isExcluded = this.excludableStaffRoles.includes(row.role) && row.excluded;
          if (isExcluded) {
            if (nameEl) nameEl.innerHTML = '';
            if (mobileEl) mobileEl.innerHTML = '';
            return;
          }
          if (!row.name || !row.name.trim()) {
            if (nameEl) nameEl.innerHTML = `${row.displayLabel}을(를) 선택해 주세요.`;
            result = false;
          } else if (nameEl) {
            nameEl.innerHTML = '';
          }
          if (!row.mobile || !row.mobile.trim()) {
            if (mobileEl) mobileEl.innerHTML = `${row.displayLabel}의 휴대전화 번호를 입력해 주세요.`;
            result = false;
          } else if (mobileEl) {
            mobileEl.innerHTML = '';
          }
        });

        // 거래처 상호 길이 검증 (modusign metadata 80자 제한)
        const clientNameCheck = validateContractClientNameLength({
          name: this.clientData.companyName,
          manager: this.clientData.ceo.name,
          mobile: this.clientData.contact.mobile,
        });
        if (!clientNameCheck.ok) {
          this.$refs.companyName.classList.add('error');
          document.getElementById('company-name-error').innerHTML = clientNameCheck.message;
          // 상호 칸 잠금을 풀어 사용자가 직접 줄일 수 있게 한다 (거래처 검색으로는 해결 불가)
          this.clientNameLengthExceeded = true;
          result = false;
        } else if (this.clientData.companyName) {
          this.$refs.companyName?.classList.remove('error');
          const _el = document.getElementById('company-name-error');
          if (_el) _el.innerHTML = '';
        }

        return result;
      }

      const validateMobileNumber = async (input) => {
        if (!input) return false;
        if (!input.startsWith('01') || input.length < 12) {
          return false;
        }
        if (input.startsWith('010-0')) {
          return false;
        }
        if (input.startsWith('01') && !input.startsWith('010') && input.length < 12) {
          return false;
        }
        if (input.startsWith('010') && input.length < 13) {
          return false;
        }
        return true;
      }

      // [2026-08-27] 참여자 전화번호 중복 가드 — 프릭스는 참여자 간 전화번호 중복(하이픈 무시)을
      // 403 DUPLICATED_PARTICIPANT_PHONE 으로 거부해, 발행이 "신규 계약서 작성에 실패하였습니다"
      // 로만 보였다(운영 실측 2026-08-27: 매수인=센터장 동번호·담당자=센터장 동번호 각각 403,
      // 번호를 전부 다르게 하면 같은 폼에서 즉시 성공). 실사용(모두싸인 V4 267건)의 13%가 동번호
      // 유형이라 발행 전에 어떤 참여자끼리 겹치는지 짚어준다.
      // 유일한 허용 = 담당자·지점장 동번호: contracts-api 가 변형 템플릿(mgr-branch)으로 한 사람
      // 병합 발행한다. 판정 기준은 BE isManagerAlsoBranchHeadV4 와 동일(실번호 숫자만 비교)이어야
      // 하며, 여기서 다른 쌍을 허용하면 BE 병합 없이 프릭스 403 으로 되돌아간다.
      const findDuplicatePhoneMessage = () => {
        const digits = (v) => String(v || '').replace(/\D/g, '');
        const participants = [{ label: '매수인', mobile: this.clientData.contact.mobile }];
        this.staffRows.forEach((row) => {
          if (this.excludableStaffRoles.includes(row.role) && row.excluded) return;
          participants.push({ label: row.role, mobile: row.mobile });
        });
        for (let i = 0; i < participants.length; i++) {
          for (let j = i + 1; j < participants.length; j++) {
            const a = participants[i];
            const b = participants[j];
            const da = digits(a.mobile);
            const db = digits(b.mobile);
            if (!da || !db || da !== db) continue;
            const pair = [a.label, b.label].sort().join('|');
            if (pair === '담당자|지점장') continue; // 담당자가 지점장 겸직 — 변형 템플릿으로 병합 발행
            return `${a.label}과(와) ${b.label}의 휴대전화 번호가 같습니다.\n전자서명 시스템은 서로 다른 참여자의 동일한 번호를 지원하지 않아 계약서를 생성할 수 없습니다. 번호를 확인해 주세요.\n(담당자가 지점장을 겸하는 경우에만 동일 번호가 허용됩니다.)`;
          }
        }
        return '';
      }

      const validateData = async () => {
        const isRequiredFilled = await validateRequiredValues();
        if (!isRequiredFilled) {
          await oneBtnDialog('필수값 누락', '필수값을 모두 입력해 주세요.', false);
          return false;
        }

        const isCeoMobileNumberValid = await validateMobileNumber(this.clientData.contact.mobile);
        if (!isCeoMobileNumberValid) {
          this.$refs.companyMobileNumber.classList.add('error');
          document.getElementById('mobile-error').innerHTML = '휴대폰 번호를 올바르게 입력해 주세요.';
          await oneBtnDialog('휴대폰 번호 오류', '휴대폰 번호를 올바르게 입력해 주세요.', false);
          return false;
        } else {
          this.$refs.companyMobileNumber.classList.remove('error');
          document.getElementById('mobile-error').innerHTML = '';
        }

        // 영업담당자 서명자 휴대폰 번호 유효성 검증 (지점장/센터장 "없음" 체크 시 스킵)
        for (let index = 0; index < this.staffRows.length; index++) {
          const row = this.staffRows[index];
          const isExcluded = this.excludableStaffRoles.includes(row.role) && row.excluded;
          if (isExcluded) continue;
          const valid = await validateMobileNumber(row.mobile);
          if (!valid) {
            const mobileEl = document.getElementById(`staff-${index}-mobile-error`);
            if (mobileEl) mobileEl.innerHTML = `${row.displayLabel}의 휴대전화 번호를 올바르게 입력해 주세요.`;
            await oneBtnDialog('휴대폰 번호 오류', '휴대폰 번호를 올바르게 입력해 주세요.', false);
            return false;
          }
        }

        // 참여자 간 전화번호 중복 가드 (담당자=지점장 겸직만 허용 — 상단 findDuplicatePhoneMessage 주석 참조)
        const dupPhoneMessage = findDuplicatePhoneMessage();
        if (dupPhoneMessage) {
          await oneBtnDialog('참여자 전화번호 중복', dupPhoneMessage, false);
          return false;
        }

        if (parseInt(this.contractInfo.discountRate, 10) < 0 || parseInt(this.contractInfo.discountRate, 10) > 100) {
          this.$refs.discountRate.classList.add('error');
          document.getElementById('discount-rate-error').innerHTML = '단가 할인율을 올바르게 입력해 주세요.';
          await oneBtnDialog('단가 할인율 오류', '단가 할인율을 올바르게 입력해 주세요.', false);
          return false;
        } else {
          this.$refs.discountRate.classList.remove('error');
          document.getElementById('discount-rate-error').innerHTML = '';
        }

        // 구매 금액(분류별) 합계가 입력됐는데 총 계약 금액과 다르면 사용자 확인 후 진행 (차단 아님)
        const itemSum = Object.values(this.itemAmounts).reduce((acc, v) => acc + (parseInt(v, 10) || 0), 0);
        const totalPrice = parseInt(this.contractInfo.totalPrice, 10) || 0;
        if (itemSum > 0 && itemSum !== totalPrice) {
          const proceed = await twoBtnDialog(
            '구매 금액 합계 불일치',
            `물품 명세 구매 금액 합계(${itemSum.toLocaleString()}원)가 총 계약 금액(${totalPrice.toLocaleString()}원)과 다릅니다. 이대로 계약서를 생성하시겠습니까?`,
            '생성',
          );
          if (!proceed) return false;
        }

        return true;
      }
      const parseClientData = (client) => {
        this.clientData.address = '';
        this.clientData.ceo.name = '';
        this.clientData.ceo.birthday = null;
        this.clientData.contact.mobile = '';
        this.clientData.contact.phone = '';

        if (client.bizAddr || (client.addrOne && client.addrTwo && client.addrThree)) {
          this.clientData.address = client.bizAddr;
          this.$refs.address.classList.remove('error');
          document.getElementById('address-error').innerHTML = '';
        }
        if (client.ceo) {
          this.clientData.ceo.name = client.ceo;
          this.$refs.ceoName.classList.remove('error');
          document.getElementById('ceo-name-error').innerHTML = '';
        }
        if (client.ceoBirthDay) {
          this.clientData.ceo.birthday = dayjs(client.ceoBirthDay);
          this.$refs.ceoBirthday.classList.remove('error');
          document.getElementById('ceo-birthday-error').innerHTML = '';
        }
        if (client.ceoMobile) {
          this.clientData.contact.mobile = phoneNumberFormatter(client.ceoMobile);
          this.$refs.companyMobileNumber.classList.remove('error');
          document.getElementById('mobile-error').innerHTML = '';
        }
        // 거래처 담당 영업사원 지점을 지점명으로 자동완성 (V1/V2와 동일 소스: empInfo.empDept)
        if (client.empInfo?.empDept) {
          this.confirmInfo.branch = client.empInfo.empDept;
          this.$refs.branch.classList.remove('error');
          document.getElementById('branch-error').innerHTML = '';
        }
        // 거래처 소속 담당 영업사원을 담당자로 자동선택 (V1/V2와 동일 소스: empInfo.empName)
        if (client.empInfo?.empName) {
          const empDept = client.empInfo.empDept || '';
          let idx = this.managerAccounts.findIndex(
            (a) => a.name === client.empInfo.empName && (!empDept || (a.deptName || '') === empDept),
          );
          if (idx < 0) idx = this.managerAccounts.findIndex((a) => a.name === client.empInfo.empName);
          if (idx >= 0) {
            this.uiHandler.onSelectStaff(0, idx);
            // 디렉토리에 연락처가 없으면 거래처에 등록된 담당자 연락처로 보완
            if (!this.staffRows[0].mobile && client.empInfo.empMobile) {
              this.staffRows[0].mobile = phoneNumberFormatter(client.empInfo.empMobile);
            }
          }
        }
      }

      // getDateFromEpochTime은 payload/mulpumV6Payload.js로 옮겨갔다(makeContractParam이
      // 그 모듈을 호출하므로 여기선 더 이상 쓰이지 않는다). getEpochTimeFromDate(역변환, 임시저장
      // 복원용)는 이 화면에만 남아있는 로직이라 그대로 둔다.
      const getEpochTimeFromDate = (dateString) => {
        if (!dateString) return 0;
        return dayjs(dateString, 'YYYY-MM-DD');
      }

      const changeMobileNumber = (isCeo) => {
        if (isCeo) {
          this.clientData.contact.mobile = phoneNumberFormatter(this.clientData.contact.mobile);
          this.$refs.companyMobileNumber.classList.remove('error');
          document.getElementById('mobile-error').innerHTML = '';
        }
      }

      const handleFirstPaymentDate = (value) => {
        this.firstPaymentDate = value;
        this.$refs.firstPaymentDate.classList.remove('error');
        document.getElementById('first-payment-date-error').innerHTML = '';
      }
      const handleInstallDate = (value) => {
        this.confirmInfo.installDate = value;
        this.$refs.installDate.classList.remove('error');
        document.getElementById('install-date-error').innerHTML = '';
      }
      const handleContractDate = (value) => {
        this.contractDate = value;
        this.$refs.contractDate.classList.remove('error');
        document.getElementById('contract-date-error').innerHTML = '';
      }
      const handleRemoveError = (ref, id) => {
        this.$refs[ref]?.classList.remove('error');
        const el = document.getElementById(id);
        if (el) el.innerHTML = '';
      }

      // 결제 방법/조건/물품 명세 핸들러
      const handlePaymentMethod = (item) => {
        this.selectedPaymentMethod = item;
        document.getElementById('payment-method-error').innerHTML = '';
        // 신용카드가 아닌 방법으로 변경 시 카드사명 초기화
        if (item.name !== '신용카드') {
          this.cardCompany = '';
          const el = document.getElementById('card-company-error');
          if (el) el.innerHTML = '';
        }
      }
      const handlePaymentCondition = (item) => {
        this.selectedPaymentCondition = item;
        // 개월 없는 조건 선택 시 개월값 초기화
        if (!item.hasMonths) this.paymentMonths = '';
        document.getElementById('payment-condition-error').innerHTML = '';
      }
      const handlePaymentMonths = (e) => {
        this.paymentMonths = e.target.value.replace(/\D/g, '');
        document.getElementById('payment-months-error').innerHTML = '';
      }
      const handleItemAmount = (key, e) => {
        this.itemAmounts[key] = parseInt(e.target.value.replace(/[^0-9]/g, '')) || 0;
      }

      const buildAccountOptions = () => {
        this.accountOptions = this.managerAccounts.map((acc, idx) => ({
          label: `${acc.name} (${acc.duty || '-'} / ${acc.deptName || '-'})`,
          value: idx,
        }));
      }

      // form state → API 요청 바디 조립은 순수 함수(mulpumV6Payload.js)로 뽑았다. 여기서는
      // this.* 를 state 객체로 얕게 모아 넘기기만 한다 — 로직 자체는 그쪽에 있고 여기선 바뀐 게 없다.
      const makeContractParam = () => buildMulpumV6Payload({
        templateId: this.templateId,
        contractType: this.contractType,
        contractTitle: this.contractTitle,
        contractCreator: this.contractCreator,
        description: this.contractInfo.description,
        clientData: this.clientData,
        itemAmounts: this.itemAmounts,
        promotionCode: this.contractInfo.promotionCode,
        discountRate: this.contractInfo.discountRate,
        selectedPaymentMethod: this.selectedPaymentMethod,
        cardCompany: this.cardCompany,
        selectedPaymentCondition: this.selectedPaymentCondition,
        paymentMonths: this.paymentMonths,
        firstPaymentDate: this.firstPaymentDate,
        staffRows: this.staffRows,
        excludableStaffRoles: this.excludableStaffRoles,
        attach2Items: this.attach2Items,
        confirmInfo: this.confirmInfo,
        contractDate: this.contractDate,
        totalPrice: this.contractInfo.totalPrice,
      })

      const createContract = async () => {
        await this.apiHandler.createContract(
            makeContractParam(),
            async (response) => {
              // 배포이후 항상 SECURE_LINK 로 생성
              this.secureLinkParam = {
                contractId: response.data.id,
                participantId: response.data.participants[0]?.id,
              }
              this.uiHandler.handleModal.createSuccess.show()
            }, async (error) => {
              await oneBtnDialog('계약 추가 실패', '신규 계약서 작성에 실패하였습니다.', false);
            }
        )
      }
      return {
        searchAddress: () => {
          new daum.Postcode({
            oncomplete: (data) => {
              var addr = '';
              if (data.userSelectedType === 'R') {
                addr = data.roadAddress;
              } else {
                addr = data.jibunAddress;
              }
              this.clientData.address = addr;
              if (this.clientData.address) {
                this.$refs.address.classList.remove('error');
                document.getElementById('address-error').innerHTML = '';
              }
            }
          }).open();
        },
        handlePercentage: async (e) => {
          let value = e.target.value;
          value = value.replace(/[^0-9.]/g, "");
          if (value.startsWith('0')) {
            let i = 0;
            while (value.charAt(i) === '0' && i < value.length - 1) i++;
            value = value.slice(i);
          }
          const dotIndex = value.indexOf('.');
          if (dotIndex !== -1) {
            const nextDotIndex = value.indexOf('.', dotIndex + 1);
            if (nextDotIndex !== -1) {
              value = value.slice(0, nextDotIndex);
            }
          }
          if (dotIndex !== -1 && dotIndex < value.length - 3) {
            value = value.slice(0, dotIndex + 3);
          }
          if (parseFloat(value) > 100) {
            await oneBtnDialog('입력값 오류', '할인율은 최대 100을 넘을 수 없습니다.', false);
            value = '100';
          }
          this.contractInfo.discountRate = value;
        },
        handlePaymentMethod,
        handlePaymentCondition,
        handlePaymentMonths,
        handleItemAmount,
        // v1의 getContractTemplate 핸들러(및 api.js의 동명 함수)는 정의만 있고 어디서도 호출되지
        // 않는 죽은 코드였다(uiHandler.getContractTemplate() 호출부가 템플릿/스크립트 전체에 없음,
        // 성공 콜백도 빈 함수). v2에서는 제거했다 — v1 파일은 건드리지 않으므로 v1 쪽엔 그대로 남는다.
        changeMobileNumber,
        changeStaffMobile: (index) => {
          this.staffRows[index].mobile = phoneNumberFormatter(this.staffRows[index].mobile);
          const mobileEl = document.getElementById(`staff-${index}-mobile-error`);
          if (mobileEl) mobileEl.innerHTML = '';
        },
        filterAccountOption: (input, option) => {
          return String(option.label).toLowerCase().includes(String(input).toLowerCase());
        },
        // 역할·지점 기반 후보 축소: 지점명 일치 직원만, 지점장/센터장 행은 해당 직급만.
        // 일치 항목이 하나도 없으면 전체로 폴백(지점명 수기 입력·직급 미등록 케이스에서 선택 불가 방지)
        accountOptionsFor: (row) => {
          const all = this.managerAccounts.map((acc, idx) => ({acc, idx}));
          let pool = all;
          if (row.role === '지점장' || row.role === '센터장') {
            const byDuty = pool.filter(({acc}) => (acc.duty || '').includes(row.role));
            if (byDuty.length) pool = byDuty;
          }
          const branch = (this.confirmInfo.branch || '').trim();
          if (branch && row.role !== '센터장') {
            const byBranch = pool.filter(({acc}) => (acc.deptName || '') === branch);
            if (byBranch.length) pool = byBranch;
          }
          return pool.map(({acc, idx}) => ({
            label: `${acc.name} (${acc.duty || '-'} / ${acc.deptName || '-'})`,
            value: idx,
          }));
        },
        onSelectStaff: (index, value) => {
          this.staffRows[index].accountId = value;
          const acc = this.managerAccounts[value];
          if (acc) {
            this.staffRows[index].name = acc.name || '';
            this.staffRows[index].deptName = acc.deptName || '';
            // 연락처가 비어있는 계정이 많음 → 있으면 채우고, 없으면 사용자가 직접 입력
            this.staffRows[index].mobile = acc.mobile ? phoneNumberFormatter(acc.mobile) : '';
          }
          const nameEl = document.getElementById(`staff-${index}-name-error`);
          if (nameEl) nameEl.innerHTML = '';
        },
        handleStaffExcluded: (row) => {
          if (row && row.excluded) {
            // "지점장/센터장 없음" 체크 시 입력값 클리어
            row.accountId = null;
            row.name = '';
            row.deptName = '';
            row.mobile = '';
            const idx = this.staffRows.indexOf(row);
            const nameEl = document.getElementById(`staff-${idx}-name-error`);
            const mobileEl = document.getElementById(`staff-${idx}-mobile-error`);
            if (nameEl) nameEl.innerHTML = '';
            if (mobileEl) mobileEl.innerHTML = '';
          }
        },
        handleFirstPaymentDate,
        handleInstallDate,
        handleContractDate,
        handleCeoBirthday: (value) => {
          this.clientData.ceo.birthday = value;
          this.$refs.ceoBirthday.classList.remove('error');
          document.getElementById('ceo-birthday-error').innerHTML = '';
        },
        removeTotalPrice,
        addZeroToTotalPrice,
        handleTotalPrice,
        handleRemoveError,
        handleModal: {
          client: {
            show: () => this.modal.client.show = true,
            close: () => this.modal.client.show = false,
            handleEvent: {
              selectClient: async (client) => {
                this.clientData.rawHospitalData = client;
                this.clientData.cNo = businessNumberFormatter(client.cNo);
                this.clientData.companyName = client.name;
                this.$refs.companyName.classList.remove('error');
                document.getElementById('company-name-error').innerHTML = '';
                // 새 거래처를 고르면 상호 칸을 다시 잠근다.
                // 이 거래처도 한도를 넘으면 뒤따르는 미리보기 가드가 곧바로 다시 열어준다.
                this.clientNameLengthExceeded = false;
                parseClientData(client);
                this.modal.client.show = false;
              }
            }
          },
          summary: {
            show: async () => {
              if (!await validateData()) return;
              this.summary = {
                계약명: this.contractTitle,
                병원명: `${this.clientData.companyName} (${this.clientData.cNo ? this.clientData.cNo : '거래처 직접 입력 - 사업자등록번호 발급전 입니다.'})`,
                병원장명: this.clientData.ceo.name,
                "병원 주소": `${this.clientData.address}`,
                "병원 연락처": `(휴대전화) ${this.clientData.contact.mobile}`,
                "총 계약 금액": this.contractInfo?.totalPrice
              }
              this.modal.summary.show = true
            },
            close: () => this.modal.summary.show = false,
            handleEvent: {
              summaryConfirm: async (childPassParam) => {
                await createContract();
              }
            }
          },
          createSuccess: {
            show: () => {
              this.modal.summary.show = false;
              this.modal.createSuccess.show = true
            },
            close: () => this.modal.createSuccess.show = false,
          },
          contractDraftModal: {
            show: async () => {
              this.$store.commit('setIsLoading', true);
              await this.uiHandler.makeContractDraft();
              this.modal.contractDraft.show = true
              this.$store.commit('setIsLoading', false);
            },
            close: () => this.modal.contractDraft.show = false
          }
        },
        getUserInfo: () => {
          const data = JSON.parse(getProfile(localStorageEnums.CompanyInfo));
          this.contractCreator = data?.accountInfo?.username;
        },
        loadManufacturerAccounts: async () => {
          await this.apiHandler.getManufacturerAccounts((response) => {
            this.managerAccounts = response?.data?.docs ?? [];
            buildAccountOptions();
          }, async (error) => {
            console.error('Failed to load manufacturer accounts', error);
          });
        },
        makeContractDraft: async () => {
          this.previewLoading = true
          // 거래처 상호 길이 가드: 미리보기/초안 자동생성 경로 (modusign metadata 80자 제한)
          const _previewClientNameCheck = validateContractClientNameLength({
            name: this.clientData.companyName,
            manager: this.clientData.ceo.name,
            mobile: this.clientData.contact.mobile,
          });
          if (!_previewClientNameCheck.ok) {
            this.$refs.companyName.classList.add('error');
            document.getElementById('company-name-error').innerHTML = _previewClientNameCheck.message;
            // 상호 칸 잠금 해제 (미리보기 자동생성 경로에서도 동일하게 열어준다)
            this.clientNameLengthExceeded = true;
            this.previewLoading = false;
            return;
          } else if (this.clientData.companyName) {
            this.$refs.companyName?.classList.remove('error');
            const _el = document.getElementById('company-name-error');
            if (_el) _el.innerHTML = '';
          }
          // 직원 연락처 가드: 디렉토리에 연락처가 없는 계정(담당자·센터장에 다수)을 선택하거나
          // 번호를 입력하다 만 상태이면 모두싸인이 서명수단 value 형식 검증에서 초안 생성을 거부한다.
          // 선택은 됐는데 연락처가 비었거나 형식이 깨진 행을 필드 단위로 짚어주고 초안 호출을 건너뛴다.
          // (아직 아무도 선택하지 않은 작성 초기 상태는 미리보기를 계속 허용)
          const _staffBadMobile = this.staffRows.filter(row => {
            if (this.excludableStaffRoles.includes(row.role) && row.excluded) return false;
            if (!String(row.name || '').trim()) return false;
            return !isModuSignMobile(row.mobile);
          });
          this.staffRows.forEach((row, index) => {
            const _mEl = document.getElementById(`staff-${index}-mobile-error`);
            if (!_mEl) return;
            if (!_staffBadMobile.includes(row)) {
              _mEl.innerHTML = '';
              return;
            }
            _mEl.innerHTML = String(row.mobile || '').trim()
                ? `${row.displayLabel}의 휴대전화 번호를 올바르게 입력해 주세요.`
                : `${row.displayLabel}의 휴대전화 번호를 입력해 주세요.`;
          });
          if (_staffBadMobile.length) {
            this.previewLoading = false;
            return;
          }
          // 참여자 간 전화번호 중복 가드 — 미리보기(초안 생성)도 같은 프릭스 발행 경로라 403 이 난다.
          const _dupPhoneMessage = findDuplicatePhoneMessage();
          if (_dupPhoneMessage) {
            await oneBtnDialog('참여자 전화번호 중복', _dupPhoneMessage, false);
            this.previewLoading = false;
            return;
          }
          await this.apiHandler.createContractDraft(
              makeContractParam(),
              async (response) => {
                this.modal.contractDraft.embeddedUrl = `${response?.data?.embeddedUrl}&mode=preview`;
              }, async (error) => {
                await oneBtnDialog('계약 초안 생성 실패', '신규 계약서 초안 생성에 실패하였습니다.', false);
              }
          ).finally(() => this.previewLoading = false)
        },
        checkScreenSizeAndFetch: async () => {
          if (this.makeContractDraftDebouncing) {
            clearTimeout(this.makeContractDraftDebouncing);
          }
          const thisObj = this;
          this.makeContractDraftDebouncing = setTimeout(async function () {
            await thisObj.uiHandler.makeContractDraft();
          }, 500);
        },
        checkDirectInputClientName: (e) => {
          // 매수인 정보 클리어
          this.clientData.companyName = ''
          this.clientData.ceo.name = ''
          this.clientData.ceo.birthday = null
          this.clientData.cNo = ''
          this.clientData.address = ''
          this.clientData.contact.mobile = ''
          this.clientData.licenseNo = ''
          // 상호가 비워졌으므로 길이 초과 상태도 해제한다
          this.clientNameLengthExceeded = false
          // 체크박스 토글
          this.directInputClientName = e.target.checked
        },
        /**
         * 상호를 직접 줄이는 동안 남은 여유 글자 수를 실시간으로 안내한다.
         * 한도 아래로 내려가도 입력칸을 다시 잠그지는 않는다 (타이핑 중 잠김 방지).
         */
        handleClientNameInput: () => {
          const check = validateContractClientNameLength({
            name: this.clientData.companyName,
            manager: this.clientData.ceo.name,
            mobile: this.clientData.contact.mobile,
          });
          const el = document.getElementById('company-name-error');
          if (check.ok) {
            this.$refs.companyName?.classList.remove('error');
            if (el) el.innerHTML = '';
          } else {
            this.$refs.companyName?.classList.add('error');
            if (el) el.innerHTML = check.message;
          }
        },
        /**
         * 영문 별칭 괄호부를 제거한 후보를 상호에 적용한다.
         * 자동 적용이 아니라 사용자가 버튼을 눌러 확정하는 경로다.
         */
        stripClientNameAlias: () => {
          const candidate = stripAsciiParenthetical(this.clientData.companyName);
          if (!candidate) return;
          this.clientData.companyName = candidate;
          this.uiHandler.handleClientNameInput();
        },
        createTempContract: async (e) => {
          const confirm = await twoBtnDialog('안내', '계약서를 임시저장 하시겠습니까?', '저장')
          if (confirm) {
            await this.apiHandler.createTempContract({
              contractType: this.contractType,
              payload: {...makeContractParam(), directInputClientName: this.directInputClientName}
            }, (response) => {
              console.log("create temp contract==>", response)
            }, (error) => {
              console.log("create temp contract==>", error)
            })
          }
        },
        loadTempContract: async () => {
          await this.apiHandler.getTempContract({
            contractType: this.contractType,
          }, async (result) => {
            const {payload} = result
            if (payload) {
              const confirm = await twoBtnDialog('안내', '임시저장된 계약서 내용이 있습니다. 불러오시겠습니까?', '확인')
              if (confirm) {
                const clientInfo = payload.clientInfos[0]
                const confirmInfo = payload.confirmInfo
                const paymentDetails = payload.paymentDetails || {}

                // 병원정보
                this.clientData.companyName = clientInfo.companyName
                this.clientData.ceo.name = clientInfo.representative
                this.clientData.ceo.birthday = clientInfo.birthday ? getEpochTimeFromDate(clientInfo.birthday) : null
                this.clientData.cNo = clientInfo.bizNo
                this.clientData.address = clientInfo.address
                this.clientData.contact.mobile = clientInfo.mobile
                this.clientData.contact.email = clientInfo.email
                this.clientData.licenseNo = clientInfo.licenseNo || ''
                this.directInputClientName = payload.directInputClientName
                // 물품 명세 / 프로모션 / 할인율
                if (payload.itemAmounts) {
                  const toNum = (v) => parseInt(String(v).replace(/[^0-9]/g, '')) || 0
                  this.itemAmounts.implant = toNum(payload.itemAmounts.implant)
                  this.itemAmounts.material = toNum(payload.itemAmounts.material)
                  this.itemAmounts.equipment = toNum(payload.itemAmounts.equipment)
                  this.itemAmounts.etc = toNum(payload.itemAmounts.etc)
                }
                this.contractInfo.promotionCode = payload.promotionCode || ''
                this.contractInfo.discountRate = payload.discountRate || ''
                // 계약 정보
                this.contractDate = getEpochTimeFromDate(confirmInfo.contractDate)
                this.confirmInfo.branch = confirmInfo.branch || ''
                this.confirmInfo.installDate = confirmInfo.installDate ? getEpochTimeFromDate(confirmInfo.installDate) : null
                this.contractInfo.totalPrice = payload.amountNum
                // 임시저장 복원은 @input 핸들러를 타지 않으므로 4줄 제한을 직접 적용
                this.contractInfo.description = (payload.description || '').split('\n').slice(0, 4).join('\n')
                // 결제 정보
                this.selectedPaymentMethod = this.paymentMethods.find(p => p.name === paymentDetails.paymentMethod) || null
                // 복원값은 maxlength를 타지 않으므로 2자 제한을 직접 적용 (계약서 괄호 폭 한계)
                this.cardCompany = (paymentDetails.cardCompany || '').slice(0, 2)
                this.selectedPaymentCondition = this.paymentConditions.find(c => c.name === paymentDetails.paymentCondition) || null
                this.paymentMonths = paymentDetails.paymentMonths || ''
                this.firstPaymentDate = paymentDetails.firstPaymentDate ? getEpochTimeFromDate(paymentDetails.firstPaymentDate) : dayjs()
                // 별첨2 (프로모션/구성 코드)
                if (Array.isArray(payload.attach2Items)) {
                  this.attach2Items = this.attach2Items.map(item => {
                    const saved = payload.attach2Items.find(s => s.group === item.group)
                    if (saved) {
                      return {...item, checked: !!saved.checked, code: saved.code || ''}
                    }
                    return item
                  })
                }
                // 영업담당자 서명자
                if (Array.isArray(payload.staffSigners)) {
                  this.staffRows = this.staffRows.map(row => {
                    const signer = payload.staffSigners.find(s => s.role === row.role)
                    if (signer) {
                      // 셀렉트 표시 복원: 디렉토리에서 성명+부서 매칭, 실패 시 이름 문자열을 그대로 표시
                      const matchedIdx = this.managerAccounts.findIndex(
                        (a) => a.name === signer.name && (!signer.deptName || (a.deptName || '') === signer.deptName),
                      )
                      return {
                        ...row,
                        name: signer.name || '',
                        deptName: signer.deptName || '',
                        mobile: signer.mobile || '',
                        excluded: this.excludableStaffRoles.includes(row.role) ? !!signer.excluded : false,
                        accountId: matchedIdx >= 0 ? matchedIdx : (signer.name || null),
                      }
                    }
                    return row
                  })
                }
                // 계약서 미리보기에 반영하기
                await this.uiHandler.makeContractDraft()
              }
            }
          }, (err) => {
            console.log("get temp contract error==>", err);
          })
        },
        // v3 양식부터 비고 셀 확장(53pt) — 폰트 9 기준 4줄 수용 — v4도 동일 유지
        limitTextToFourLines: () => {
          const lines = this.contractInfo.description.split('\n');
          if (lines.length > 4) {
            this.contractInfo.description = lines.slice(0, 4).join('\n');
          }
        },
      }
    },
    api() {
      // v2: contracts-api 인스턴스 바인딩 (v1의 this.$apiInstance 대신 contractsApiInstance)
      return contractApi(contractsApiInstance, this.$store)
    },
  }
}
</script>
<style scoped>
.titleContainer {
  margin-bottom: 30px;

  .title {
    font-size: 24px;
    font-weight: bold;
    color: #2F3337;
    line-height: 1.2;
    margin-bottom: 5px;
    letter-spacing: 0;
  }

  .desc {
    color: #6e747c;
    font-weight: 400;
  }
}

@media screen and (max-width: 767px) {
  textarea {
    width: 100% !important;
  }
}
</style>
<style scoped lang="scss">
@import '@/assets/scss/contract-detail.scss';
</style>
